<template>
  <div>
    <el-dialog
      width="90%"
      :title="TitleForDialog"
      :visible.sync="DialoVisible"
      @close="OnDialogClose"
      @open="OnDIalogOpen"
    >
      <el-row>
        <RequestPerDayInAMonthBarChart
          :DialoVisible="DialoVisible"
          :YearSelected="YearSelected"
          :ThecnicianSelected="ThecnicianSelected"
          :CustomerServiceCode="CustomerServiceCode"
          :Month="Month"
          :ModuleId="ModuleId"
          :RequestTypeSelected="RequestTypeSelected"
        />
      </el-row>
      <el-row>
        <rabbey-table-3
          :data="detailData"
          :columns="detailColumns"
          :actions="detailActions"
          :loading="detailLoading"
          :paginationApi="paginationApi"
        />
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button @click="OnDialogClose">Cerrar</el-button>
        <!-- <el-button type="primary" @click="DialoVisible = true">open the inner Dialog</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { COLUMNAS } from "@/views/modules/technical_support/requests/requests";
import RequestPerDayInAMonthBarChart from "@/components/requests/reports/ReportByModuleByMonth/charts/RequestByModulePerDayInAMonthBarChart";

const actualYear = new Date().getFullYear();

export default {
  name: "MonthlyRequestsByProductsReportDetail",
  components: {
    RequestPerDayInAMonthBarChart
  },
  props: {
    DialoVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    YearSelected: {
      type: Number,
      default: actualYear
    },
    ThecnicianSelected: {
      type: [Number, null]
    },
    CustomerServiceCode: {
      type: [Number, null]
    },
    Month: {
      type: [Number, null]
    },
    ModuleId: {
      type: [Number, null]
    },
    ModuleName: {
      type: String,
      default: ""
    },
    RequestTypeSelected: {
      type: [Number, null]
    }
  },
  data() {
    return {
      detailData: [],
      detailColumns: COLUMNAS,
      detailActions: [],
      detailLoading: false,
      paginationApi: {
        currentPage: 1,
        pageSize: 500,
        total: 0
      },
      months: {
        1: "Enero",
        2: "Febrero",
        3: "Marzo",
        4: "Abril",
        5: "Mayo",
        6: "Junio",
        7: "Julio",
        8: "Agosto",
        9: "Septiembre",
        10: "Octubre",
        11: "Noviembre",
        12: "Diciembre"
      }
    };
  },
  computed: {
    TitleForDialog() {
      let title = `Solicitudes de ${this.ModuleName} del mes de ${
        this.months[this.Month]
      }`;
      return title;
    }
  },
  // async mounted() {
  //   await this.GetDetailData();
  // },
  methods: {
    OnDialogClose() {
      this.$emit("ClosingDialog", false);
    },
    async OnDIalogOpen() {
      await this.GetDetailData();
    },
    async GetDetailData() {
      this.detailLoading = true;

      await this.$http
        .get(
          "api/serviceRequests/GetPagedServiceRequestsByModuleAndMonthAsync",
          {
            params: {
              Id: null,
              ClientCode: null,
              companyCode: "VF",
              Status: null,
              moduleId: this.ModuleId,
              month: this.Month,
              year: this.YearSelected,
              responsibleId: this.ThecnicianSelected,
              CustomerService: this.CustomerServiceCode,
              ServiceRequestTypeId: this.RequestTypeSelected
            }
          }
        )
        .then((resp) => {
          this.detailData = resp.data.Items;
          this.paginationApi.currentPage = resp.data.CurrentPage;
          this.paginationApi.total = resp.data.ItemCount;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.detailLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
